export default __webpack_public_path__ + "static/media/advantages__item-icon-5.af7878f2.svg";